import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-none transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1';
  const variants = {
    primary: 'bg-copper text-charcoal hover:bg-opacity-90',
    secondary: 'bg-transparent border-2 border-copper text-copper hover:bg-copper hover:text-charcoal'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseClasses} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-206">
      {children}
    </motion.button>;
}